<template>
  <div>
    <div v-if="userType==4">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>后台管理</el-breadcrumb-item>
        <el-breadcrumb-item>老师工作汇报</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div v-else>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/text' }">老师管理系统</el-breadcrumb-item>
        <el-breadcrumb-item>学生管理</el-breadcrumb-item>
        <el-breadcrumb-item>学生汇报查看</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-card>
      <el-row>
        <el-col :span="4">
          <div class="grid-content bg-purple-dark">
            <el-input v-model="inputTitle" placeholder="请输入汇报人" @keyup.enter.native="searWork"></el-input>
          </div>
        </el-col>
        <el-col :span="9">
          <div class="block">
    <el-date-picker
      v-model="value2"
      type="daterange"
      align="right"
      unlink-panels
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      :picker-options="pickerOptions">
    </el-date-picker>
  </div>
        </el-col>
        <el-col :span="2">
          <div class="grid-content bg-purple">
            <el-button type="primary" @click="searWork">查询</el-button>
           
           
          </div>
        </el-col>
          <el-col :span="3"> <p class="lableforSearch">查询到{{Worklist.length}}条数据</p></el-col>
      </el-row>

      <el-table ref="multipleTable" :data="Worklist" border show-overflow-tooltip="true" tooltip-effect="dark"
        @row-click="showsWork">

        <el-table-column label="汇报人" show-overflow-tooltip width="120" prop="name">

        </el-table-column>
        <el-table-column label="汇报标题" show-overflow-tooltip width="120" prop="work_TITLE">

        </el-table-column>
        <el-table-column prop="work_CONTENT" label="完成工作" width="180" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="problem" :show-overflow-tooltip="true" label="存在问题" width="180">
        </el-table-column>
        <el-table-column prop="proposal" :show-overflow-tooltip="true" label="其他建议" width="180">
        </el-table-column>

        <el-table-column prop="name" label="姓名" width="120">
        </el-table-column>
        <el-table-column prop="type" label="填写人类型" width="120" :formatter="typeFormat">
        </el-table-column>
        <el-table-column prop="createDate" label="汇报时间" width="180">
        </el-table-column>

        <el-table-column prop="checkWork" label="是否查看" :formatter="stateFormat" width="120">
        </el-table-column>
        <el-table-column prop="username" label="审核账户" width="180">
        </el-table-column>
        <el-table-column prop="message" show-overflow-tooltip label="留言" width="120">
        </el-table-column>
      </el-table>


    </el-card>

    <el-dialog title="工作汇报" :visible.sync="dialogVisible" width="50%">

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog width="50%" :visible.sync="catwork">
      <el-dialog width="30%" :visible.sync="innerVisible" append-to-body>

        <el-form label-width="80px">
          <el-form-item label="留言:" prop="message">
            <el-input type="textarea" v-model="message"></el-input>
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="updateTeacherWork(workshowlist)">确定</el-button>
        <el-button type="primary" @click="innerVisible=false">取消</el-button>
      </el-dialog>

      <InsertWorkModel :WORK_CONTENT="workshowlist.work_CONTENT" :title="workshowlist.work_TITLE"
        :problem="workshowlist.problem" :proposal="workshowlist.proposal" :createDate="workshowlist.createDate" :name="name" >
      </InsertWorkModel>
      <el-button type=" primary" v-if="userType==4 &workshowlist.checkWork!=true" @click="innerVisible=true">审批
      </el-button>
      <el-button type=" primary" @click="catwork=false">取消</el-button>
    </el-dialog>


  </div>
</template>

<script>
import InsertWorkModel from '@/components/work/student/InsertWorkModel.vue'

export default {
  components: {
    InsertWorkModel,
  },
  created() {
    this.getwork()


  },

  data() {
    return {
      name:'',
      inputTitle: '',
      multipleSelection: [],
      message: '',
      searTitleList:'',
      innerVisible: false,
      tableData: [],
      userType: '',
      Worklist: [],
      catwork: false,
      input: '',
      workshowlist: {},
      teacherList: [],
      teacher: '',
      showVisible: false,
      dialogVisible: false,
      ruleForm: {
        WORK_TITLE: '',
        WORK_CONTENT: '',
        WORK_COMPLETE: '',
        userid: '',
        value1: '',
        work_BEGIN_TIME: '',
        work_END_TIME: '',
      },  pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        value2: '',
      rules: {
        WORK_TITLE: [
          { required: true, message: '汇报标题', trigger: 'blur' },
          { min: 3, max: 50, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        WORK_CONTENT: [
          { required: true, message: '汇报内容', trigger: 'blur' },
          { min: 3, max: 200, message: '长度在 3 到 200 个字符', trigger: 'blur' }
        ],
        WORK_COMPLETE: [
          { required: true, message: '请选择汇报进度', trigger: 'blur' },

        ],
        value1: [
          { required: true, message: '汇报内容', trigger: 'blur' }
        ]

      }


    }
  },
  props: ['user'],
  methods: {
    getwork(title) {
      this.userType = JSON.parse(localStorage.getItem('user')).type
      this.ruleForm.userid = JSON.parse(localStorage.getItem('user')).userid
      console.log(this)
      if (this.userType == 4) {
        if (title == undefined) { title = '' }
        this.axios.post("/work/getWorkByTeacher?work_TITLE=" + title)
          .then(resp => {
            if (resp.data.status == 1) {
              resp.data.result.work_END_TIME = this.format(resp.data.result.work_END_TIME, 'yyyy-MM-dd HH:mm:ss')
              this.Worklist = resp.data.result
              console.log(this.Worklist)
            }
          })
      } else {
        this.axios.post("/work/getWorkByTeacher", 'teacherID=' + this.ruleForm.userid)
          .then(resp => {
            if (resp.data.status == 1) {
              resp.data.result.work_END_TIME = this.format(resp.data.result.work_END_TIME, 'yyyy-MM-dd HH:mm:ss')
              this.Worklist = resp.data.result
            }
          })
      }
    }, searWork() {
      const starDate=this.format(this.value2[0], 'yyyy-MM-dd HH:mm:ss')
      const endDate=this.format(this.value2[1], 'yyyy-MM-dd HH:mm:ss')
      // this.getwork(this.inputTitle)
      if(this.searTitleList.length<=0){
          this.searTitleList=this.Worklist
        }
        this.Worklist=this.searTitleList
        // .includes
        this.Worklist=this.Worklist.filter((item)=>{
         if(this.inputTitle!=''){
          return item.name.includes(this.inputTitle)
         }else{
          return true
         }     
        })

  
        this.Worklist=this.Worklist.filter((item)=>{
         if(this.value2.length>0){
          return starDate<item.createDate&&item.createDate<endDate
         }else{
          return true
         }     
        })


    }, updateTeacherWork(data) {
      let fd = new FormData();
      let config = { headers: { "Content-Type": "application/json" } };
      fd.append("message", this.message)
      fd.append('work_ID', data.work_ID);
      fd.append('checkWork', true);
      fd.append('checkUserId', JSON.parse(localStorage.getItem("user")).userid);
      this.axios.post("/work/updateTeacherWork", fd, config)
        .then(resp => {
          if (resp.data.status == 1) {
            this.$message.success("已查看")
            this.message = ''
            this.catwork = false
            this.innerVisible = false
            this.getwork()
          } else {
            alert("拿取数据失败")
          };
        })
        .catch((err) => {
          // alert("出错了")
          console.log(err)
        })
      console.log(data)
    },
    showsWork(date) {
      console.log(date)
      this.catwork = true
      this.axios.post("/work/getWorkByWorkid", "wordid=" + date.work_ID)
        .then(resp => {
          if (resp.data.status === 1) {
            this.workshowlist = resp.data.result[0]
            this.name=date.name
          }
        })
    }, stateFormat(row, column) {
      if (row.checkWork === null) {
        return '未查看'
      } else if (row.checkWork == 0) {
        return '未通过'
      } else {
        return '已查看'
      }
    }, typeFormat(row, column) {
      if (row.type === 0) {
        return '老师'
      } else if (row.type == 5) {
        return '辅导员'
      } else {
        return '其他'
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    format(time, format) {
      var t = new Date(time);
      var tf = function (i) { return (i < 10 ? '0' : '') + i };
      return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
        switch (a) {
          case 'yyyy':
            return tf(t.getFullYear());
            break;
          case 'MM':
            return tf(t.getMonth() + 1);
            break;
          case 'mm':
            return tf(t.getMinutes());
            break;
          case 'dd':
            return tf(t.getDate());
            break;
          case 'HH':
            return tf(t.getHours());
            break;
          case 'ss':
            return tf(t.getSeconds());
            break;
        }
      })
    }

  },

}

</script>

<style>
.report_content {
  width: 100%;
  height: 100%;
  background-color: red;
}

.el-card {
  margin-top: 20px;
}
 .lableforSearch{
      margin-top:8px;
      color:grey
}
</style>


// WEBPACK FOOTER //
// src/components/work/teacher/ViewStudentWork.vue